import { defineMessage } from 'services/localization';

export const messages = {
    fieldTransactionNumber: defineMessage('exp_rept'),
    fieldEmployee: defineMessage('employee'),
    fieldAccount: defineMessage('account'),
    fieldCurrency: defineMessage('currency'),
    fieldAdvance: defineMessage('advance_to_apply_1'),
    fieldMemo: defineMessage('purpose'),
    fieldDate: defineMessage('date'),
    fieldPostingPeriod: defineMessage('posting_period_1'),
    fieldDueDate: defineMessage('due_date_1'),
    fieldClass: defineMessage('class'),
    fieldDepartment: defineMessage('department'),
    fieldLocation: defineMessage('location'),
    fieldAccountCorporateCard: defineMessage('account_for_corporate_card_expenses_1'),
    sectionExpensesTitle: defineMessage('expenses'),
    openInNetSuiteLinkText: defineMessage('open_in_netsuite'),
    columnRefLineNumber: defineMessage('ref_no'),
    columnExpenseDate: defineMessage('date'),
    columnCategory: defineMessage('category'),
    columnExpenseAccount: defineMessage('expense_account_1'),
    columnQuantity: defineMessage('quantity'),
    columnUnitPrice: defineMessage('rate'),
    columnForeignAmount: defineMessage('foreign_amount'),
    columnCurrency: defineMessage('currency'),
    columnExchangeRate: defineMessage('exchange_rate_1'),
    columnAmount: defineMessage('amount'),
    columnTaxCode: defineMessage('tax_code'),
    columnTaxRate: defineMessage('tax_rate'),
    columnTaxAmount: defineMessage('tax_amount'),
    columnGrossAmount: defineMessage('gross_amount'),
    columnMemo: defineMessage('memo'),
    columnDepartment: defineMessage('department'),
    columnClass: defineMessage('class'),
    columnLocation: defineMessage('location'),
    columnCustomer: defineMessage('customer_project'),
    columnIsBillable: defineMessage('is_billable'),
    columnIsBillableTooltip: defineMessage('is_billable'),
    columnIsNonReimbursable: defineMessage('nonreimbursable'),
    columnIsNonReimbursableTooltip: defineMessage('nonreimbursable'),
    columnLineAttachment: defineMessage('attach_file'),
    columnIsReceipt: defineMessage('receipt'),
    columnIsReceiptTooltip: defineMessage('receipt'),
    columnIsCorporateCreditCard: defineMessage('corporate_card'),
    columnIsCorporateCreditCardTooltip: defineMessage('corporate_card'),
};
